import React from 'react';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';
import { PLACEHOLDER } from '../../constants';

export default function Table({ randomWidths }) {
  return (
    <>
      <ContentLoader height={20} width={400}>
        <rect x="0" y="13" width={PLACEHOLDER.TABLE.ddWidth} height={PLACEHOLDER.TABLE.ddHeight} />
        <rect
          x="300"
          y="13"
          width={PLACEHOLDER.TABLE.ddWidth}
          height={PLACEHOLDER.TABLE.ddHeight}
        />
      </ContentLoader>
      {[...new Array(10)].map((e, i) => (
        <TableRow
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          style={{ opacity: Number(2 / i).toFixed(1) }}
          randomWidths={randomWidths}
        />
      ))}
    </>
  );
}

Table.defaultProps = {
  randomWidths: true
};

Table.propTypes = {
  randomWidths: PropTypes.bool
};

function TableRow({ randomWidths, ...props }) {
  const random = (randomWidths ? Math.random() : 1) * (1 - 0.7) + 0.7;
  const spacing = PLACEHOLDER.TABLE.spacing;
  const cellWidth = PLACEHOLDER.TABLE.cellWidth;
  const cellHeight = PLACEHOLDER.TABLE.cellHeight;
  return (
    <ContentLoader
      height={PLACEHOLDER.TABLE.height}
      width={PLACEHOLDER.TABLE.width}
      speed={PLACEHOLDER.TABLE.speed}
      primaryColor={PLACEHOLDER.TABLE.primaryColor}
      secondaryColor={PLACEHOLDER.TABLE.secondaryColor}
      {...props}
    >
      <rect x="0" y="13" width={cellWidth * random} height={cellHeight} />
      <rect x={spacing} y="13" width={cellWidth * random} height={cellHeight} />
      <rect x={spacing * 2} y="13" width={cellWidth * random} height={cellHeight} />
      <rect x={spacing * 3} y="13" width={cellWidth * random} height={cellHeight} />
      <rect x={spacing * 4} y="13" width={cellWidth * random} height={cellHeight} />
      <rect x={spacing * 5} y="13" width={cellWidth * random} height={cellHeight} />
      <rect x={spacing * 6} y="13" width={cellWidth * random} height={cellHeight} />
      <rect x={spacing * 7} y="13" width={cellWidth * random} height={cellHeight} />
    </ContentLoader>
  );
}

TableRow.defaultProps = {
  randomWidths: true
};

TableRow.propTypes = {
  randomWidths: PropTypes.bool
};
